// extracted by mini-css-extract-plugin
export default {"group":"field_group__hjqo3","label":"field_label__E9Z6t","legend":"field_legend__AhRt2","error":"field_error__Gqkds"};